import i18next from '../i18n'
import * as Utils from '../utils/charts'
export const intervals = [
  { value: '3 months', label: 'timeRange.3M' },
  { value: '6 months', label: 'timeRange.6M' },
  { value: '1 year', label: 'timeRange.1Y' },
  // { value: '2 years', label: 'timeRange.2Y' },
  // { value: '5 years', label: 'timeRange.5Y' },
]

export const getChartsData = (labels?: any | [], capitals?: any | [], label?: string) => {
  return {
    labels: labels,
    datasets: [{
      label: label || i18next.t('capitalBalance'),
      data: capitals,
      backgroundColor: Utils.transparentize(Utils.CHART_COLORS.blue, 0.3),
      fill: true,
      hoverBackgroundColor: "#9DA6AB",
      borderColor: Utils.transparentize(Utils.CHART_COLORS.blue, 0.3),
      tension: 0.2

    }]
  }
}


export const getPieChartsData = (labels?: any | [], values?: any | []) => {
  return {
    labels: labels,
    datasets: [{
      label: i18next.t('valuePercent'),
      data: values,
      backgroundColor: [
        Utils.transparentize(Utils.CHART_COLORS.blue, 0),
        Utils.transparentize(Utils.CHART_COLORS.yellow, 0),
        Utils.transparentize(Utils.CHART_COLORS.red, 0),
        Utils.transparentize(Utils.CHART_COLORS.green, 0),
        Utils.transparentize(Utils.CHART_COLORS.orange, 0),
        Utils.transparentize(Utils.CHART_COLORS.purple, 0),
        Utils.transparentize(Utils.CHART_COLORS.grey, 0),
      ],
      tension: 0.1

    }]
  }
}


